import React from "react";
import LcField from "./LcField";

export default function PasswordField(props) {
  return (
    <LcField
      name="user[password]"
      text="Password (at least 8 characters)"
      errorMessage={props.errorMessage}
    >
      <input
        className="input-md"
        id="user[password]"
        type="password"
        name="password"
        autoCapitalize="off"
        autoCorrect="off"
        onChange={props.onChange}
        onBlur={props.onBlur}
        value={props.value}
      />
    </LcField>
  );
}
